import React, { useState } from 'react';
//internal and external components import
import Table from '@mui/material/Table';
import TableBody from '@mui/material/TableBody';
import TableCell from '@mui/material/TableCell';
import TableContainer from '@mui/material/TableContainer';
import { TableRow, Checkbox, Chip, TextField, ThemeProvider, createTheme, Tooltip, Typography  } from '@mui/material';
import { stableSort, getComparator } from '../../common/SortSupport';
import { EnhancedTableHead } from '../EnhancedTableHead';
import { Box } from '@mui/material';
import ActionDetailPopper from '../../containers/ActionDetailPopper';
import { accountingSupportFund } from '../../assets/staticData';
import YenTextField from '../YenTextField';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faXmark, faCheck, faTrash } from '@fortawesome/free-solid-svg-icons';
import { useDispatch, useSelector } from 'react-redux';
import { setIsUpdatedSupportFund, setSupportFundDetails } from '../../redux/reducers/dataCaptures';
import { deleteSupportFund } from '../../api/dataCapture';
import { useTranslation } from 'react-i18next';
import { isEmpty } from '../../common/StaticExports';

const theme = createTheme({
  components: {
    MuiStack: {
      styleOverrides: {
        root: {
          display: 'inline',
          width: '90px'
        }
      }
    },
    MuiTextField: {
      styleOverrides: {
        root: {
          minWidth: '90px !important',
        }
      }
    },
    MuiInputBase: {
      styleOverrides: {
        input: {
          fontSize: 12
        }
      }
    },
    MuiSvgIcon: {
      styleOverrides: {
        root: {
          width: 18,
          height: 18
        }
      }
    }
  },
})

const AccountingSupportFundTable = (props?: any) => {
  const { addRow, handleClick } = props;
  const [newData, setNewData]:any = useState({});
  const data = useSelector((state:any) => state.dataCaptures.supportFundDetails);
  const dispatch = useDispatch();
  const [t] = useTranslation();
  const isAdmin = useSelector((state:any) => state.common.isAdmin);

  //supporting contents
  const [order, setOrder] = React.useState('');
  const [orderBy, setOrderBy] = React.useState('');

  const handleRequestSort = (
    event: React.MouseEvent<unknown>,
    property: any,
  ) => {
    const isAsc = orderBy === property && order === 'asc';
    setOrder(isAsc ? 'desc' : 'asc');
    setOrderBy(property);
  };

  const visibleRows = React.useMemo(
    () =>
      data?.length > 0 &&
      stableSort(data, getComparator(order, orderBy)),
    [order, orderBy, data],
  );

  const head = [
    {
        key: 'description', displayName: 'description',
    },
    {
        key: 'amount', displayName: 'amount',
    },
    {
        key: 'supportFundContribution', displayName: 'supportFundContribution',
    },
    {
        key: '', displayName: '',
    },
  ]

  
  const updateState = ((updatedRow:any) => {
    const updatedList = data?.map((item:any) => ((item?.id !== null && item?.id == updatedRow?.id) || item?.tempId == updatedRow?.tempId) ? updatedRow : item);
    dispatch(setSupportFundDetails(updatedList));
    const boolean:any = true;
    dispatch(setIsUpdatedSupportFund(boolean));
  });
  
  const manageDeleteRow = (row: any) => {
    let updatedList:any = [];
    if(row?.id) {
      deleteSupportFund({ clubId: row?.clubId, id: row?.id });
      updatedList = data?.filter((d:any) => d?.id != row?.id);
    } else {
      updatedList = data?.filter((d:any) => d?.tempId != row?.tempId);
    }
    dispatch(setSupportFundDetails(updatedList));
    const boolean:any = true;
    dispatch(setIsUpdatedSupportFund(boolean));
  }

  const manageCreatenew = () => {
    const tempData = {...newData, tempId: Math.random()}
    const updatedList:any = [...data, tempData];
    dispatch(setSupportFundDetails(updatedList));
    const boolean:any = true;
    dispatch(setIsUpdatedSupportFund(boolean));
    setNewData({});
    handleClick();
  }

  const fetchTotalSFAmount = () => {
    const total = data?.reduce((acc:any, curr:any) => {
      return acc + (curr?.amount ? parseFloat(curr?.amount) : 0);
    }, 0);
    return total+' ¥';
  }

  //table contents
    return(
        <React.Fragment>
          <ThemeProvider theme={theme}>
          <Box sx={{ position: 'relative' }}>
              <TableContainer>
                <Table stickyHeader size="small" aria-label="a dense table">
                    <EnhancedTableHead
                    order={order}
                    orderBy={orderBy}
                    onRequestSort={handleRequestSort}
                    tableHeads={head}
                    bg={'#FAFAFA'}
                    />
                    <TableBody>
                    {
                    visibleRows && visibleRows?.length &&
                    visibleRows?.map((d: any, i: number) => (
                        <TableRow
                        sx={{ cursor: 'pointer' }}
                        key={`accountingpl-table-row-${i}`}
                        >
                            <TableCell className='fs12' width={520}>
                                <TextField variant='standard' sx={{ width: '100%' }} value={d.description} onChange={(e:any) => {updateState({ ...d, description: e.target.value})}} error={isEmpty(d.description)} helperText={isEmpty(d.description) ? t('REQUIRED') : ''} disabled={isAdmin} />
                            </TableCell>
                            <TableCell className='fs12'>
                                <YenTextField v={d.amount} manageChange={(e:any) => {updateState({ ...d, amount: e})}} isError={isEmpty(d.amount)} errorMessage={t('REQUIRED')} isReadOnly={isAdmin} />
                            </TableCell>
                            <TableCell className='fs12'>
                                <Checkbox sx={{ padding: '0px' }} checked={d.supportFundContribution} onClick={() => {updateState({ ...d, supportFundContribution: !d?.supportFundContribution})}} disabled={isAdmin} />
                            </TableCell>
                            <TableCell>
                              {
                                !isAdmin &&
                                <Tooltip title='Delete' arrow placement='top'>
                                  <FontAwesomeIcon 
                                  onClick={() => {manageDeleteRow(d)}} 
                                  className={'icon mr10 deleteIcon'} 
                                  icon={faTrash}/>
                                </Tooltip>
                              }
                            </TableCell>
                        </TableRow>

                    ))}
                      {
                        !isAdmin &&
                        addRow &&
                        <TableRow
                        sx={{ cursor: 'pointer' }}
                        key={`accountingpl-table-add-row`}
                        >
                            <TableCell className='fs12' width={520}>
                                <TextField variant='standard' sx={{ width: '100%' }} value={newData?.description} onChange={(e:any) => {setNewData({ ...newData, description: e.target.value})}} error={isEmpty(newData?.description)} helperText={isEmpty(newData?.description) ? t('REQUIRED') : ''}/>
                            </TableCell>
                            <TableCell className='fs12'>
                                <YenTextField v={newData?.amount} manageChange={(e:any) => {setNewData({ ...newData, amount: e})}} isError={isEmpty(newData?.amount)} errorMessage={t('REQUIRED')} />
                            </TableCell>
                            <TableCell className='fs12'>
                                <Checkbox sx={{ padding: '0px' }} checked={newData?.supportFundContribution}  onClick={() => {setNewData({ ...newData, supportFundContribution: !newData?.supportFundContribution})}}/>
                            </TableCell>
                            <TableCell>
                              <Tooltip title='Delete' arrow placement='top'>
                                <FontAwesomeIcon onClick={() => {handleClick(); setNewData({});}} className={'icon mr10'} icon={faXmark}/>
                              </Tooltip>
                              <Tooltip title='Create' arrow placement='top'>
                                <FontAwesomeIcon className={'icon mr10'} icon={faCheck} onClick={manageCreatenew}/>
                              </Tooltip>
                            </TableCell>
                        </TableRow>
                      }
                        <TableRow
                        key={`accountingsf-table-row-total`}
                        >
                            <TableCell className='fs12' width={520}>
                              {t('TOTAL')}
                            </TableCell>
                            <TableCell className='fs12'>
                              {fetchTotalSFAmount()}
                            </TableCell>
                            <TableCell className='fs12'>
                            </TableCell>
                            <TableCell>
                            </TableCell>
                        </TableRow>
                    </TableBody>
                </Table>
              </TableContainer>
              <Typography className='fs13'>
              </Typography>
            </Box>
          </ThemeProvider>
        </React.Fragment>
    )
}

export default AccountingSupportFundTable;